import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
    getPendingSocialVerification,
    saveSocialVerificationResult,
    clearPendingSocialVerification,
} from "../../utils/socialVerificationSession";
import {
    completeSocialVerification,
    parseSocialVerificationState,
} from "../../api/socialVerificationApi";

const SocialVerificationCallback = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const run = async () => {
            const code = searchParams.get("code") || "";
            const state = searchParams.get("state") || "";
            const pendingVerification = getPendingSocialVerification() || {};
            const parsedState = parseSocialVerificationState(state);
            const platform = searchParams.get("platform") || parsedState.platform || pendingVerification.platform || "";
            const handle = searchParams.get("handle") || parsedState.handle || pendingVerification.handle || "";
            const returnTo = searchParams.get("returnTo") || parsedState.returnTo || "/register";
            const index = parsedState.index ?? pendingVerification.index ?? null;
            const errorMessage =
                searchParams.get("error_description") ||
                searchParams.get("error_message") ||
                searchParams.get("message") ||
                searchParams.get("error") ||
                "";

            if (code) {
                const result = await completeSocialVerification({ platform, code, state });
                saveSocialVerificationResult({
                    platform,
                    handle: result?.handle || handle,
                    status: result?.status || "verified",
                    message: result?.message || "",
                    index,
                });
                clearPendingSocialVerification();
                navigate(result?.redirectTo || returnTo, { replace: true });
                return;
            }

            const status = searchParams.get("status") || (errorMessage ? "error" : "pending");
            const message = errorMessage;

            saveSocialVerificationResult({
                platform,
                handle,
                status,
                message,
                index,
            });
            clearPendingSocialVerification();
            navigate(returnTo, { replace: true });
        };

        run();
    }, [navigate, searchParams]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
            <div>
                <p className="text-sm font-medium text-slate-700">{t("AUTH_SOCIAL_VERIFICATION_LOADING")}</p>
                <p className="mt-2 text-sm text-slate-500">{t("AUTH_SOCIAL_VERIFICATION_WAIT")}</p>
            </div>
        </div>
    );
};

export default SocialVerificationCallback;
